import React from 'react';

export default function About() {
  return (
    <div className="min-h-screen bg-spice-light">
      {/* Header */}
      <div className="bg-spice-surface border-b border-spice-border py-12 sm:py-20 text-center relative overflow-hidden px-4">
        <div className="flex items-center justify-center gap-2 mb-3 sm:mb-4">
          <span className="h-[1px] w-8 bg-spice-red"></span>
          <span className="text-spice-red font-bold text-xs uppercase tracking-[0.2em]">Our Story</span>
          <span className="h-[1px] w-8 bg-spice-red"></span>
        </div>
        <h1 className="text-3xl md:text-5xl font-serif font-bold mb-3 sm:mb-4 text-spice-dark">A Legacy of Purity</h1>
        <p className="text-sm sm:text-base md:text-lg text-spice-muted max-w-2xl mx-auto">
          From a small family mill to India's premier spice manufacturer.
        </p>
      </div>

      {/* Main Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10 py-10 sm:py-20 pb-36">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 sm:gap-16 items-center mb-12 sm:mb-24">
          <div>
            <img src="https://images.unsplash.com/photo-1596040033229-a9821ebd058d?auto=format&fit=crop&q=80&w=800" alt="Spice Market" referrerPolicy="no-referrer" className="rounded-2xl shadow-xl border border-spice-border grayscale-[20%]" />
          </div>
          <div>
            <div className="flex items-center gap-2 mb-3 sm:mb-4">
              <span className="h-[1px] w-8 bg-spice-red"></span>
              <span className="text-spice-red font-bold text-xs uppercase tracking-[0.2em]">Our Roots</span>
            </div>
            <h2 className="text-2xl md:text-3xl font-serif font-bold text-spice-dark mb-4 sm:mb-6">Generations of Flavor</h2>
            <p className="text-spice-muted mb-4 leading-relaxed text-sm">
              Founded with a mission to bring unadulterated, farm-fresh spices to every kitchen, Ajjas Masala has grown from a small family grinding unit to a state-of-the-art manufacturing facility.
            </p>
            <p className="text-spice-muted leading-relaxed text-sm">
              We source our raw materials directly from the fields of Guntur (Chillis), Salem (Turmeric), and Rajasthan (Coriander & Cumin), ensuring that farmers get a fair price and we get the best quality produce.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 sm:gap-16 items-center mb-0 md:flex-row-reverse">
          <div className="order-2 md:order-1">
            <div className="flex items-center gap-2 mb-4">
              <span className="h-[1px] w-8 bg-spice-red"></span>
              <span className="text-spice-red font-bold text-xs uppercase tracking-[0.2em]">Our Process</span>
            </div>
            <h2 className="text-2xl md:text-3xl font-serif font-bold text-spice-dark mb-6">Modern Processing & Hygiene</h2>
            <p className="text-spice-muted mb-4 leading-relaxed text-sm">
              Our traditional recipes are backed by modern technology. We utilize fully automated cleaning, roasting, and grinding machinery that ensures our spices remain untouched by human hands throughout the process.
            </p>
            <p className="text-spice-muted leading-relaxed text-sm">
              Our advanced cooling-grinding technology retains the volatile oils inside the spices, meaning you get the maximum aroma, flavor, and health benefits in every pinch.
            </p>
          </div>
          <div className="order-1 md:order-2">
            <img src="https://images.unsplash.com/photo-1542838132-92c53300491e?auto=format&fit=crop&q=80&w=1000" alt="Modern machinery" referrerPolicy="no-referrer" className="rounded-none shadow-xl border border-spice-border grayscale-[30%]" />
          </div>
        </div>
      </div>
    </div>
  );
}
